var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.997 11q.002-.23.002-.5C22 6.91 19.313 4 16 4s-6 2.91-6 6.5q0 .27.003.5H6.094a2 2 0 0 0-1.984 2.254l1.665 13A2 2 0 0 0 7.76 28h16.478a2 2 0 0 0 1.984-1.747l1.657-13A2 2 0 0 0 25.893 11zM20 10.5l-.001.42c-.167.017-.371.031-.623.043C18.59 11 17.52 11 16 11s-2.59 0-3.376-.037a12 12 0 0 1-.622-.043l-.002-.42C12 7.861 13.938 6 16 6s4 1.861 4 4.5M6.094 13 7.76 26h16.478l1.657-13z",
    clipRule: "evenodd"
  })));
};
export default SvgBasket;